import { Grid } from '@material-ui/core';
import { FieldArray } from 'formik';
import React, { Fragment } from 'react';
import CompraRetencaoItem from './CompraRetencaoItem';
import { compraRetencaoListStyles } from './styles';

const CompraRetencaoList = ({
  id,
  name,
  errors,
  onChange,
  onBlur,
  values,
  touched,
  minDate,
  onAddRetencao,
  submitCount,
  compraPaga,
}) => {
  const styles = compraRetencaoListStyles();

  return (
    <FieldArray
      id={id}
      name={name}
      render={(arrayHelpers) => {
        return (
          <>
            {values
              ?.filter((retencao) => !!retencao)
              .map((retencao, index) => {
                return (
                  <Fragment key={retencao.key}>
                    <CompraRetencaoItem
                      values={retencao}
                      onChange={onChange}
                      onBlur={onBlur}
                      index={index}
                      id={`${id}[${index}]`}
                      name={`${name}[${index}]`}
                      errors={(errors?.length >= index && errors[index]) || {}}
                      touched={(touched?.length >= index && touched[index]) || {}}
                      arrayHelpers={arrayHelpers}
                      //   onRemove={onRemove}
                      showDivider={values?.length > 1 && index !== values?.length - 1}
                      submitCount={submitCount}
                      minDate={minDate}
                      compraPaga={compraPaga}
                    />
                  </Fragment>
                );
              })}
            {values?.length > 0 && values?.length < 10 && (
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <button
                    className={styles.buttonAdicionarRetencao}
                    type="button"
                    href=""
                    onClick={onAddRetencao}
                    disabled={compraPaga}
                  >
                    Adicionar mais retenção
                  </button>
                </Grid>
              </Grid>
            )}
          </>
        );
      }}
    />
  );
};

export default CompraRetencaoList;
